(() => {
  const elementsWithBeforePseudo = window.WeakSet ? new WeakSet() : new Set();
  const elementsWithAfterPseudo = window.WeakSet ? new WeakSet() : new Set();

  document.addEventListener('animationend', (e) => {
    const target = window.swinger.eventHub.getTarget(e);

    if (typeof target !== 'object') {
      return;
    }

    switch (e.animationName) {
      default:
        break;

      case 'swinger-dummy-before':
        elementsWithBeforePseudo.add(target);
        break;

      case 'swinger-dummy-after':
        elementsWithAfterPseudo.add(target);
        break;
    }
  }, true);

  window.swinger = {
    ...window.swinger,
    pseudoElementTracker: {
      hasElemBeforePseudo: (elem) => elementsWithBeforePseudo.has(elem),
      hasElemAfterPseudo: (elem) => elementsWithAfterPseudo.has(elem),
    },
  };
})();
